import { MutableRefObject, useEffect } from 'react'

const useOutsideClickListener = (
  refs: Array<HTMLButtonElement | HTMLDivElement | MutableRefObject<HTMLDivElement | null>>,
  callback: () => void
) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    function handleClickOutside(event) {
      refs.forEach(ref => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (ref.current && !ref.current.contains(event.target)) {
          callback()
        }
      })
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs])
}

export default useOutsideClickListener
